<mat-form-field appearance="outline" class="yearMonthPickerComponent" color="accent">
  <mat-label>
    {{ label }}
  </mat-label>

  <input class="datepicker-readonly" readonly matInput [matDatepicker]="picker" [formControl]="control" [min]="minDate"
    [max]="maxDate" [lang]="language" />

  <button type="button" class="button--clear mat-icon-button" [formControl]="control" (click)="clearDate(control)"
    matTooltip="{{'clear' | translate | async}}">
    <mat-icon>
      clear
    </mat-icon>
  </button>

  <mat-datepicker-toggle class="datepicker" matSuffix [for]="picker" matTooltip="{{ 'open-calendar' | translate | async }}"
    matTooltipPosition="below">
  </mat-datepicker-toggle>

  <mat-datepicker #picker></mat-datepicker>

</mat-form-field>